import React from 'react';
import { Container, Button, Alert, Table } from 'reactstrap';
export class ChanceElement extends React.Component {
    constructor(props) {
        super(props);

    }


    componentDidMount() {



    }

    render() {

        if (this.props.data === null) {
            return <div>
            </div>;
        }

        var l=this.props.reverseNum.length;
        var number=this.props.data.number.toString();
        var l2=number.length;
        var nump1="";
        for(var i=0;i<l;i++)
        {
            nump1= this.props.reverseNum[i]+ nump1;
        }
        var nump2="";
        for(var i=l ;i<l2;i++ )
        {
            nump2= nump2+number[i-l] ;
        }

        return (
            <div style={{  width: "100%" }}>
                <table className=" table bg-success" style={{  borderRadius: '20px' ,border: 'none' ,boxShadow:'10px 10px'  }} >

                <tbody>
                       
                   
                        <tr style={{borderTop:'none'}}>
                            <td style={{borderTop:'none'}}>  <h4> <span>{traverse(nump2)}</span><span style={{color:"#ff7f1f"}}>{traverse(nump1)}</span></h4> </td>

                        </tr>
       
              
                        <tr>

                            <td style={{ color: "white" }}> <h4> {traverse(this.props.data.uniqueId)}</h4></td>
                        </tr>

                        <tr>

                            <td><h4>{traverse(mphone(this.props.data.mobileNumber))}</h4></td>
                        </tr>
                    </tbody>
                </table>

                

            </div>

        );
    }
}
const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el = el.toString();
    var list = el.match(/[0-9]/g);
    if (list != null && list.length != 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}
function mphone(v) {
    //var r = v.replace(/\D/g,"");
    var r = v.replace(/^(\d{3})(\d{3})(\d{4}).*/, '$3***$1');
    return r;
}



// WEBPACK FOOTER //
// ./src/elements/ChanceElement.js